/* eslint-disable no-shadow */
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import styled, { css } from 'styled-components';
import {
  OperatorStatusSelector,
  SearchCardsDropdown,
  BugsDropdown,
  ProfileDropdown,
  NotificationsDropdown,
} from '@components';
import ReportPopup from '../components/CRM/Common/ReportPopup';

import {
  changeManualStatus,
  fetchPackageUrl,
  resetGeneralErrors,
  resetCriticalErrors,
  toggleBugsDropdown,
  submitCustomReport,
  setIsNotificationsSoundEnabled,
  switchTheme,
  setVolume,
} from '../store/actions/general';
import { logoutAgentAction } from '../store/actions/agentAuth';

import {
  generalSearch,
  clientsSearch,
  ordersSearch,
  communicationsSearch,
  notesSearch,
  messagesSearch,
  selectSearchClient,
  selectSearchOrder,
  selectSearchCommunication,
  selectSearchNote,
  selectSearchMessage,
} from '../store/actions/search';

import { Logo as LogoIcon } from '@icons/crm';

import { VOX_STATES } from '@constants/vox';
import { SEARCH_CARD_TYPES } from '../constants';
import { AgentGlobalSearch } from '../modules/b2b';
import {
  getCurrentAgency,
  LEVEL_TRAVEL_AGENCY,
  MOSGORTUR_AGENCY,
} from '../modules/b2b/agency/config';
import mosgorturLogo from '../modules/b2b/agency/logos/mgt_black.png';

const FULL_SEARCH_PAGE_SIZE = 20;

const mapStateToProps = ({ appMode, dialer, search, general }, ownProps) => ({
  isAgentMode: appMode.isAgentMode,
  isAuthorized: dialer.isAuthorized,
  isWSConnected: general.isWSConnected,
  isSentryEnabled: general.isSentryEnabled,
  isMasterInstance: general.isMasterInstance,
  manualState: dialer.manualState,
  currentManager: general.currentManager,
  managerStatuses: general.managerStatuses,
  searchOrders: search.orders,
  searchClients: search.clients,
  searchCommunications: search.communications,
  searchNotes: search.notes,
  searchMessages: search.messages,
  isSearchingOrders: search.isSearchingOrders,
  isSearchingClients: search.isSearchingClients,
  isSearchingCommunication: search.isSearchingCommunication,
  isSearchingNotes: search.isSearchingNotes,
  isSearchingMessages: search.isSearchingMessages,
  hasNextSearchPage: search.hasNextPage,
  hasUpdates: general.hasAssetUpdates,
  history: ownProps.history,
  generalErrors: general.errors.general,
  criticalErrors: general.errors.critical,
  voxServerError: dialer.serverError,
  volume: general.volume,
});

const mapDispatchToProps = (dispatch) => ({
  logoutAgent: () => dispatch(logoutAgentAction()),
  fetchPackageUrl: (id) => dispatch(fetchPackageUrl(id)),
  generalSearch: (payload) => dispatch(generalSearch(payload)),
  clientsSearch: (payload) => dispatch(clientsSearch(payload)),
  ordersSearch: (payload) => dispatch(ordersSearch(payload)),
  communicationsSearch: (payload) => dispatch(communicationsSearch(payload)),
  notesSearch: (payload) => dispatch(notesSearch(payload)),
  messagesSearch: (payload) => dispatch(messagesSearch(payload)),
  selectSearchClient: (payload) => dispatch(selectSearchClient(payload)),
  selectSearchOrder: (payload) => dispatch(selectSearchOrder(payload)),
  selectSearchCommunication: (payload) =>
    dispatch(selectSearchCommunication(payload)),
  selectSearchNote: (payload) => dispatch(selectSearchNote(payload)),
  selectSearchMessage: (payload) => dispatch(selectSearchMessage(payload)),
  resetGeneralErrors: (payload) => dispatch(resetGeneralErrors(payload)),
  resetCriticalErrors: (payload) => dispatch(resetCriticalErrors(payload)),
  toggleBugsDropdown: (payload) => dispatch(toggleBugsDropdown(payload)),
  submitCustomReport: (payload) => dispatch(submitCustomReport(payload)),
  onStatusChange: (payload) => dispatch(changeManualStatus(payload)),
  setIsNotificationsSoundEnabled: (isSoundEnabled) =>
    dispatch(setIsNotificationsSoundEnabled(isSoundEnabled)),
  switchTheme: (theme) => dispatch(switchTheme(theme)),
  setVolume: (theme) => dispatch(setVolume(theme)),
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
class Header extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    isAuthorized: PropTypes.bool,
    isAgentMode: PropTypes.bool.isRequired,
    logoutAgent: PropTypes.func.isRequired,
    isWSConnected: PropTypes.bool,
    isSentryEnabled: PropTypes.bool,
    isMasterInstance: PropTypes.bool,
    currentManager: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      number: PropTypes.string,
      operatorState: PropTypes.oneOf(Object.values(VOX_STATES)),
    }),
    managerStatuses: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        value: PropTypes.string,
      })
    ),
    manualState: PropTypes.oneOf(Object.values(VOX_STATES)),
    hasNextSearchPage: PropTypes.bool.isRequired,
    hasUpdates: PropTypes.bool.isRequired,
    generalSearch: PropTypes.func.isRequired,
    clientsSearch: PropTypes.func.isRequired,
    ordersSearch: PropTypes.func.isRequired,
    communicationsSearch: PropTypes.func.isRequired,
    notesSearch: PropTypes.func.isRequired,
    messagesSearch: PropTypes.func.isRequired,
    selectSearchClient: PropTypes.func.isRequired,
    selectSearchOrder: PropTypes.func.isRequired,
    selectSearchCommunication: PropTypes.func.isRequired,
    selectSearchNote: PropTypes.func.isRequired,
    selectSearchMessage: PropTypes.func.isRequired,
    resetGeneralErrors: PropTypes.func.isRequired,
    resetCriticalErrors: PropTypes.func.isRequired,
    toggleBugsDropdown: PropTypes.func.isRequired,
    submitCustomReport: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }).isRequired,
    searchOrders: PropTypes.shape().isRequired,
    searchClients: PropTypes.shape().isRequired,
    searchCommunications: PropTypes.shape().isRequired,
    searchNotes: PropTypes.shape().isRequired,
    searchMessages: PropTypes.shape().isRequired,
    isSearchingOrders: PropTypes.bool.isRequired,
    isSearchingClients: PropTypes.bool.isRequired,
    isSearchingCommunication: PropTypes.bool.isRequired,
    isSearchingNotes: PropTypes.bool.isRequired,
    isSearchingMessages: PropTypes.bool.isRequired,
    generalErrors: PropTypes.shape(),
    criticalErrors: PropTypes.shape(),
    voxServerError: PropTypes.bool.isRequired,
    onStatusChange: PropTypes.func.isRequired,
    setVolume: PropTypes.func.isRequired,
    volume: PropTypes.number,
  };

  static defaultProps = {
    className: '',
    isAuthorized: false,
    isWSConnected: false,
    isSentryEnabled: false,
    isMasterInstance: false,
    manualState: VOX_STATES.OFFLINE,
    dialerState: VOX_STATES.OFFLINE,
    generalErrors: [],
    criticalErrors: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      isOpenReportModal: false,
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.handleLoadOrdersRequest = this.handleLoadOrdersRequest.bind(this);
    this.handleLoadClientRequest = this.handleLoadClientRequest.bind(this);
    this.handleLoadCommunicationRequest =
      this.handleLoadCommunicationRequest.bind(this);
    this.handleLoadNotesRequest = this.handleLoadNotesRequest.bind(this);
    this.handleLoadMessagesRequest = this.handleLoadMessagesRequest.bind(this);
    this.handleCardClick = this.handleCardClick.bind(this);
    this.handleToggleReportModal = this.handleToggleReportModal.bind(this);
  }

  handleToggleReportModal() {
    this.setState((prevState) => ({
      ...prevState,
      isOpenReportModal: !prevState.isOpenReportModal,
    }));
  }

  handleSearch(value) {
    const { generalSearch } = this.props;
    this.setState(() => ({
      searchValue: value,
    }));

    generalSearch({ query: value });
  }

  handleLoadOrdersRequest() {
    const { ordersSearch } = this.props;
    const { searchValue } = this.state;
    ordersSearch({ query: searchValue, pageSize: FULL_SEARCH_PAGE_SIZE });
  }

  handleLoadClientRequest() {
    const { clientsSearch } = this.props;
    const { searchValue } = this.state;
    clientsSearch({ query: searchValue, pageSize: FULL_SEARCH_PAGE_SIZE });
  }

  handleLoadCommunicationRequest() {
    const { communicationsSearch } = this.props;
    const { searchValue } = this.state;
    communicationsSearch({
      query: searchValue,
      pageSize: FULL_SEARCH_PAGE_SIZE,
    });
  }

  handleLoadMessagesRequest() {
    const { messagesSearch } = this.props;
    const { searchValue } = this.state;
    messagesSearch({ query: searchValue, pageSize: FULL_SEARCH_PAGE_SIZE });
  }

  handleLoadNotesRequest() {
    const { notesSearch } = this.props;
    const { searchValue } = this.state;
    notesSearch({ query: searchValue, pageSize: FULL_SEARCH_PAGE_SIZE });
  }

  handleCardClick({ item, type }) {
    const {
      selectSearchClient,
      selectSearchOrder,
      selectSearchCommunication,
      selectSearchNote,
      selectSearchMessage,
      history,
    } = this.props;
    if (type === SEARCH_CARD_TYPES.CLIENTS) {
      selectSearchClient({ clientId: item.clientId, history });
    } else if (type === SEARCH_CARD_TYPES.ORDERS) {
      selectSearchOrder({ clientId: item.clientId, history });
    } else if (type === SEARCH_CARD_TYPES.COMMUNICATION) {
      selectSearchCommunication({
        ticketId: item.ticketId,
        chainId: item.chainId,
        history,
      });
    } else if (type === SEARCH_CARD_TYPES.NOTES) {
      selectSearchNote({ ticketId: item.ticketId, history });
    } else if (type === SEARCH_CARD_TYPES.MESSAGES) {
      selectSearchMessage({
        ticketId: item.ticketId,
        chainId: item.chainId,
        history,
      });
    }
  }

  render() {
    const {
      className,
      isAgentMode,
      logoutAgent,
      isAuthorized,
      isWSConnected,
      isSentryEnabled,
      isMasterInstance,
      manualState,
      currentManager,
      managerStatuses,
      searchOrders,
      searchClients,
      searchCommunications,
      searchNotes,
      searchMessages,
      hasNextSearchPage,
      hasUpdates,
      isSearchingOrders,
      isSearchingClients,
      isSearchingCommunication,
      isSearchingNotes,
      isSearchingMessages,
      resetGeneralErrors,
      resetCriticalErrors,
      toggleBugsDropdown,
      submitCustomReport,
      generalErrors,
      criticalErrors,
      voxServerError,
      onStatusChange,
      setIsNotificationsSoundEnabled,
      switchTheme,
      setVolume,
      volume,
    } = this.props;

    const { isOpenReportModal } = this.state;
    const agency = getCurrentAgency() || MOSGORTUR_AGENCY;

    return (
      <StyledHeader className={className} isMasterInstance={isMasterInstance}>
        {isAgentMode ? (
          agency.id === LEVEL_TRAVEL_AGENCY.id ? (
            <StyledLevelTravelLogo aria-label={agency.name} />
          ) : (
            <StyledAgencyLogo src={mosgorturLogo} alt={agency.name} />
          )
        ) : (
          <StyledLogoIcon />
        )}
        <StyledSearch>
          {isAgentMode ? (
            <AgentGlobalSearch />
          ) : (
            <StyledSearchCardsDropdown
              onChange={this.handleSearch}
              orders={searchOrders}
              clients={searchClients}
              communications={searchCommunications}
              notes={searchNotes}
              messages={searchMessages}
              placeholder="Поиск..."
              onCardClick={this.handleCardClick}
              isLoadingOrders={isSearchingOrders}
              isLoadingClients={isSearchingClients}
              isLoadingCommunications={isSearchingCommunication}
              isLoadingNotes={isSearchingNotes}
              isLoadingMessages={isSearchingMessages}
              onLoadOrdersRequest={this.handleLoadOrdersRequest}
              onLoadClientsRequest={this.handleLoadClientRequest}
              onLoadCommunicationsRequest={
                this.handleLoadCommunicationRequest
              }
              onLoadNotesRequest={this.handleLoadNotesRequest}
              onLoadMessagesRequest={this.handleLoadMessagesRequest}
              hasNextPage={hasNextSearchPage}
              minimumBatchSize={FULL_SEARCH_PAGE_SIZE}
            />
          )}
        </StyledSearch>
        {!isAgentMode && (
          <StyledBugsDropdown
            list={generalErrors}
            onReset={resetGeneralErrors}
            hasSocketError={!isWSConnected}
            hasVoxError={voxServerError}
            hasUpdates={hasUpdates}
            onToggle={(isOpen) => {
              toggleBugsDropdown(isOpen);
            }}
            onOpenReport={
              isSentryEnabled
                ? () => {
                    this.handleToggleReportModal();
                  }
                : null
            }
          />
        )}
        {!isAgentMode && <StyledNotificationsDropdown />}
        {!isAgentMode && (
          <ReportPopup
            isOpenReportModal={isOpenReportModal}
            onClose={this.handleToggleReportModal}
            submitCustomReport={submitCustomReport}
          />
        )}
        <StyledProfileDropdown
          currentManager={currentManager}
          isAgentMode={isAgentMode}
          onAgentLogout={logoutAgent}
          setIsNotificationsSoundEnabled={setIsNotificationsSoundEnabled}
          switchTheme={switchTheme}
          setVolume={setVolume}
          volume={volume}
        />
        {!isAgentMode && (
          <StyledStatus
            value={currentManager?.operatorState}
            manualState={manualState}
            onChange={onStatusChange}
            options={managerStatuses}
            errors={criticalErrors}
            onErrorReset={resetCriticalErrors}
          />
        )}
      </StyledHeader>
    );
  }
}

const StyledNotificationsDropdown = styled(NotificationsDropdown)`
  margin-right: 20px;
`;

const StyledProfileDropdown = styled(ProfileDropdown)`
  font-family: inherit;
  font-size: 12px;

  div {
    font-weight: normal;
  }
`;

const StyledHeader = styled.div`
  align-items: center;
  background-color: #fff;
  display: flex;
  height: 65px;
  width: 100%;
  justify-content: space-between;
  position: relative;

  @media print {
    display: none;
  }

  ${(props) =>
    props.isMasterInstance &&
    css`
      border-left: 3px solid #09823c;
    `}
`;

const StyledSearch = styled.div`
  position: relative;
  width: 100%;
  height: 40px;
  margin-right: 20px;
`;

const StyledBugsDropdown = styled(BugsDropdown)`
  position: relative;
  height: 40px;
  margin-right: 20px;
`;

const StyledSearchCardsDropdown = styled(SearchCardsDropdown)`
  position: absolute;
  width: 100%;
  z-index: 4;
`;

const StyledLogoIcon = styled(LogoIcon)`
  height: 37px;
  min-height: 37px;
  margin: 0 15px;
  min-width: 37px;
`;

const StyledLevelTravelLogo = styled(LogoIcon)`
  flex-shrink: 0;
  height: 37px;
  margin: 0 15px;
  min-height: 37px;
  min-width: 37px;
`;

const StyledAgencyLogo = styled.img`
  flex-shrink: 0;
  height: auto;
  margin: 0 18px;
  width: 130px;
`;

const StyledStatus = styled(OperatorStatusSelector)`
  margin-right: 13px;
  max-height: 30px;
`;

export default Header;
